import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { IStateDashboardSearchFields, IStateDashboardSearchRequest } from '@core/interfaces/istate-dashboard';
import { StateService } from '@core/services/state.service';
import { take } from 'rxjs';

@Component({
    selector: 'drdp-search-special-education',
    templateUrl: './search-special-education.component.html',
    styleUrls: ['./search-special-education.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchSpecialEducationComponent {
private stateService = inject(StateService);
  
  displayDropdowns: IStateDashboardSearchFields = {
    ageGroup: false,
    enrollmentProgram: false,
    homeLanguage: false,
    schoolYear: true,
    globalRatingPeriods: false,
    disability: false
  };
  requiredFields: IStateDashboardSearchFields = {
    ageGroup: false,
    enrollmentProgram: false,
    homeLanguage: false,
    globalRatingPeriods: false,
    disability: false
  };

  handleSearch(searchValue: IStateDashboardSearchRequest): void {
    this.stateService.searchSpecialEducation(searchValue).pipe(take(1)).subscribe(res => {
      const fileName = 'SpecialEducation.xlsx';
      const blob = new Blob([res.body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
    });
  }
}